import { render, staticRenderFns } from "./roam-transaction-list.vue?vue&type=template&id=5b608873&"
import script from "./roam-transaction-list.vue?vue&type=script&lang=js&"
export * from "./roam-transaction-list.vue?vue&type=script&lang=js&"
import style0 from "./roam-transaction-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports